import { Radio } from "antd"
import React, { useState, Fragment, useEffect } from "react"
import { useWindowWidth } from '../state/hooks';
import { Distributor } from "./Distributor";
import { path } from 'ramda';
import { ShowButton } from "./ShowButton";

export const DistributorList = ({ distributors, field: { field, form }, setCoordinates }) => {

    const width = useWindowWidth();
    const [open, setOpen] = useState(true)

    const isTouched = path(['status', 'isSubmitStarted'], form);
    const error = path(['errors', field.name], form);
    const showError = error && isTouched ? 'has-error' : '';

    useEffect(()=> {
        if(width < 770) setOpen(false)
        if(error && isTouched) setOpen(true)
    }, [width, showError])

    const onChange = (distributor_id, shop_id) => {
        form.setFieldValue(field.name, distributor_id)
        form.setFieldValue('shop_id', shop_id)
    }

    const focusedCoordinates = (coords) => {
        if(width < 770) setOpen(false)
        setCoordinates(coords)
    }

    return (
        <Fragment>
            
            <ShowButton open={open} total={distributors && distributors.length} action={()=> setOpen(state => !state)}/>

            { open ? 
                <Radio.Group 
                    name={field.name} 
                    className="distributors distributors__list"
                >
                    {
                        distributors &&  
                        distributors.map(item=> item.active_shops.map(inner=> (
                            <Distributor
                                key={inner.id}
                                id={inner.id}
                                company={item.name}
                                mail={inner.email_of_responsible}
                                fullName={inner.responsible_person} 
                                phone={inner.phone}
                                additional_phone={inner.additional_phone}
                                address={inner.address}
                                className={showError}
                                onChange={()=> onChange(item.id, inner.id)}
                                onClick={()=> focusedCoordinates({ center: [inner.lat, inner.lng], zoom: 10 })}
                            />)
                        ))
                            
                    }
                </Radio.Group> : null
            }
        </Fragment>
    )
}



// WEBPACK FOOTER //
// ./src/components/pages/projects/distributors/distributorsList/DistributorList.js